
(() => {
  const WISHLIST_KEY = 'studioos-wishlist-v1';
  const RECENT_KEY = 'studioos-recently-viewed-v1';
  const LISTS_KEY = 'studioos-restock-lists-v1';

  const read = (key, fallback = []) => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback));
      return value ?? fallback;
    } catch {
      return fallback;
    }
  };

  const writeLists = (lists) => {
    localStorage.setItem(LISTS_KEY, JSON.stringify(lists));
    render();
  };

  const escapeHTML = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  }[character]));

  const productCard = (item, source) => `
    <article class="sos-dashboard-product">
      <a class="sos-dashboard-product__image" href="${escapeHTML(item.url || '#')}">
        ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" loading="lazy">` : ''}
      </a>
      <div class="sos-dashboard-product__body">
        <h3><a href="${escapeHTML(item.url || '#')}">${escapeHTML(item.title || 'Product')}</a></h3>
        <div class="sos-dashboard-product__price">${escapeHTML(item.price || '')}</div>
        <div class="sos-dashboard-product__actions">
          <a href="${escapeHTML(item.url || '#')}">View</a>
          ${item.variantId ? `<button type="button" data-dashboard-add-cart="${escapeHTML(item.variantId)}">Add</button>` : ''}
          ${source === 'favourite' ? `<button type="button" data-dashboard-add-to-list="${escapeHTML(item.handle || '')}">Save to list</button>` : ''}
        </div>
      </div>
    </article>
  `;

  const tabs = (root) => {
    root.querySelectorAll('[data-dashboard-tab]').forEach((button) => {
      button.addEventListener('click', () => activate(root, button.dataset.dashboardTab));
    });

    root.querySelectorAll('[data-dashboard-tab-target]').forEach((button) => {
      button.addEventListener('click', () => activate(root, button.dataset.dashboardTabTarget));
    });
  };

  const activate = (root, name) => {
    root.querySelectorAll('[data-dashboard-tab]').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.dashboardTab === name);
    });
    root.querySelectorAll('[data-dashboard-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.dashboardPanel === name);
    });
  };

  const renderLists = (root, lists, favourites) => {
    const container = root.querySelector('[data-dashboard-lists]');
    const empty = root.querySelector('[data-dashboard-lists-empty]');
    const select = root.querySelector('[data-dashboard-list-select]');
    if (!container || !empty || !select) return;

    select.innerHTML = lists.length
      ? lists.map((list) => `<option value="${escapeHTML(list.id)}">${escapeHTML(list.name)}</option>`).join('')
      : '<option value="">Create a list first</option>';

    container.innerHTML = lists.map((list) => `
      <article class="sos-restock-list" data-restock-list="${escapeHTML(list.id)}">
        <div class="sos-restock-list__head">
          <div><h3>${escapeHTML(list.name)}</h3><span>${list.items.length} products</span></div>
          <button type="button" data-restock-delete="${escapeHTML(list.id)}" aria-label="Delete ${escapeHTML(list.name)}">×</button>
        </div>
        <div class="sos-restock-list__items">
          ${list.items.length ? list.items.map((item) => `
            <div class="sos-restock-item">
              ${item.image ? `<img src="${escapeHTML(item.image)}" alt="">` : '<span></span>'}
              <div><strong>${escapeHTML(item.title)}</strong><span>${escapeHTML(item.price || '')}</span></div>
              <button type="button" data-restock-remove="${escapeHTML(list.id)}" data-restock-handle="${escapeHTML(item.handle || '')}">Remove</button>
            </div>
          `).join('') : '<span>No products added yet.</span>'}
        </div>
        <div class="sos-restock-list__actions">
          <button type="button" data-restock-add-cart="${escapeHTML(list.id)}" ${list.items.some(item => item.variantId) ? '' : 'disabled'}>Add list to cart</button>
          <button type="button" data-restock-add-favourites="${escapeHTML(list.id)}">Add favourites</button>
        </div>
      </article>
    `).join('');

    empty.classList.toggle('is-visible', lists.length === 0);
    container.hidden = lists.length === 0;
  };

  const render = () => {
    const root = document.querySelector('[data-studio-dashboard]');
    if (!root) return;

    const favourites = read(WISHLIST_KEY, []);
    const recent = read(RECENT_KEY, []);
    const lists = read(LISTS_KEY, []);

    root.querySelector('[data-dashboard-favourite-count]')?.replaceChildren(document.createTextNode(String(favourites.length)));
    root.querySelector('[data-dashboard-recent-count]')?.replaceChildren(document.createTextNode(String(recent.length)));
    root.querySelector('[data-dashboard-list-count]')?.replaceChildren(document.createTextNode(String(lists.length)));

    const favGrid = root.querySelector('[data-dashboard-favourites]');
    const favEmpty = root.querySelector('[data-dashboard-favourites-empty]');
    if (favGrid && favEmpty) {
      favGrid.innerHTML = favourites.map(item => productCard(item, 'favourite')).join('');
      favGrid.hidden = favourites.length === 0;
      favEmpty.classList.toggle('is-visible', favourites.length === 0);
    }

    const recentGrid = root.querySelector('[data-dashboard-recent]');
    const recentEmpty = root.querySelector('[data-dashboard-recent-empty]');
    if (recentGrid && recentEmpty) {
      recentGrid.innerHTML = recent.map(item => productCard(item, 'recent')).join('');
      recentGrid.hidden = recent.length === 0;
      recentEmpty.classList.toggle('is-visible', recent.length === 0);
    }

    renderLists(root, lists, favourites);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-dashboard-new-list]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('input');
    const name = input?.value.trim();
    if (!name) return;
    const lists = read(LISTS_KEY, []);
    lists.unshift({ id: `${Date.now()}`, name, items: [] });
    writeLists(lists);
    form.reset();
  });

  document.addEventListener('click', async (event) => {
    const root = event.target.closest('[data-studio-dashboard]');
    if (!root) return;

    const addFavourites = event.target.closest('[data-dashboard-add-favourites],[data-restock-add-favourites]');
    if (addFavourites) {
      const select = root.querySelector('[data-dashboard-list-select]');
      const listId = addFavourites.dataset.restockAddFavourites || select?.value;
      if (!listId) return;
      const favourites = read(WISHLIST_KEY, []);
      const lists = read(LISTS_KEY, []);
      const list = lists.find(item => item.id === listId);
      if (!list) return;
      const existing = new Set(list.items.map(item => item.handle));
      favourites.forEach((item) => {
        if (!existing.has(item.handle)) list.items.push(item);
      });
      writeLists(lists);
      return;
    }

    const addSingle = event.target.closest('[data-dashboard-add-to-list]');
    if (addSingle) {
      const handle = addSingle.dataset.dashboardAddToList;
      const listId = root.querySelector('[data-dashboard-list-select]')?.value;
      if (!listId) return;
      const favourite = read(WISHLIST_KEY, []).find(item => item.handle === handle);
      const lists = read(LISTS_KEY, []);
      const list = lists.find(item => item.id === listId);
      if (!favourite || !list || list.items.some(item => item.handle === handle)) return;
      list.items.push(favourite);
      writeLists(lists);
      return;
    }

    const remove = event.target.closest('[data-restock-remove]');
    if (remove) {
      const lists = read(LISTS_KEY, []);
      const list = lists.find(item => item.id === remove.dataset.restockRemove);
      if (list) list.items = list.items.filter(item => item.handle !== remove.dataset.restockHandle);
      writeLists(lists);
      return;
    }

    const deleteList = event.target.closest('[data-restock-delete]');
    if (deleteList) {
      writeLists(read(LISTS_KEY, []).filter(item => item.id !== deleteList.dataset.restockDelete));
      return;
    }

    const addCart = event.target.closest('[data-dashboard-add-cart]');
    if (addCart) {
      const button = addCart;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json', Accept:'application/json'},
          body: JSON.stringify({items:[{id:Number(button.dataset.dashboardAddCart), quantity:1}]})
        });
        if (!response.ok) throw new Error();
        button.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('studioos:cart:refresh', {detail:{open:true,source:'dashboard'}}));
      } catch {
        button.textContent = 'Try again';
      } finally {
        setTimeout(() => { button.disabled = false; button.textContent = original; }, 1400);
      }
      return;
    }

    const addList = event.target.closest('[data-restock-add-cart]');
    if (addList) {
      const list = read(LISTS_KEY, []).find(item => item.id === addList.dataset.restockAddCart);
      const items = list?.items.filter(item => item.variantId).map(item => ({id:Number(item.variantId), quantity:1})) || [];
      if (!items.length) return;
      const button = addList;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding list…';
      try {
        const response = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({items})
        });
        if (!response.ok) throw new Error();
        button.textContent = 'List added ✓';
        document.dispatchEvent(new CustomEvent('studioos:cart:refresh', {detail:{open:true,source:'restock-list'}}));
      } catch {
        button.textContent = 'Try again';
      } finally {
        setTimeout(() => { button.disabled = false; button.textContent = original; }, 1600);
      }
    }
  });

  const initialise = () => {
    const root = document.querySelector('[data-studio-dashboard]');
    if (!root) return;
    tabs(root);
    render();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, {once:true});
  } else {
    initialise();
  }

  window.addEventListener('storage', render);
  window.addEventListener('studioos:wishlist-change', render);
  document.addEventListener('shopify:section:load', initialise);
})();
